import Blog from "./Blog";
import Feature from "./Feature";
import Testimonials from "./Testimonials";
import Pricing from "./Pricing";
import Process from "./Process";
import Screenshots from "./Screenshots";
import Video from "./Video";
import Title from "./Title";
import Breaker from "./Breaker";
import ImageBlock from "./ImageBlock";
import TeamProfile from "./TeamProfile";
import Tutorial from "./Tutorial";
import Contact from "./Contact";
import BoxContent from "./BoxContent";
import tinycolor from "tinycolor2";

const Groups = ({data, color})  => {
    
  const boxContentData = [];
  let renderedBoxContent = false;
  if(color !== undefined){
    var originalColor = tinycolor(`${color.hex}`);
    var newColor = originalColor.darken(5).toString();
  }
 

// New, darker color


    return(
        <>
        {data && data.length > 0 && data.some(item => item.cc_ref_link_href) ? 
        <section className="text-center  group" id={data[0].cc_ref_link_href} style={{
          backgroundColor: color !== undefined? color.hex : '#fff',
          borderTop: newColor !== undefined ? `1px solid ${newColor}` : 'none',
          borderBottom: newColor !== undefined ? `1px solid ${newColor}` : 'none',
        }}>
        {data && data.map((dataItem) => {
        switch (dataItem._type) {
          case 'cc_title_section':
            return <Title title={dataItem.cc_title_section_heading} subTitle={dataItem.cc_title_section_title} />;
          case 'modules':
            switch (dataItem.custom_module_blocks) {
              case 'news_module':
                return <Blog />;
              case 'features_module':
                return <Feature />;
              case 'testimonials_module':
                return <Testimonials />;
              case 'prices_module':
                return <Pricing />;
              case 'teams_module':
                return <TeamProfile />;
              case 'contact_form_module':
                return <Contact />;
              default:
                return null;
            }
          case 'cc_accordion':
            return <Process data={dataItem.groups}/>;
          case 'tutorial':
            return <Tutorial data={dataItem.groups} />;
          case 'gallery':
            return <Screenshots data={dataItem.imageUrl}/>;
          case 'video':
            return <Video data={dataItem}/>;
          case 'cc_img_section':
              return <ImageBlock data={dataItem}></ImageBlock>;
          case 'cc_breaker':
              return <Breaker></Breaker>;
          case 'cc_box_content':
              boxContentData.push(dataItem);  
              if (!renderedBoxContent) {
                  renderedBoxContent = true; // Set the flag to true so no further BoxContent is rendered
                  return <BoxContent data={boxContentData} />;
              }
              return null; 
          default:
            return null;
        }
      })}
        </section>
        :
        <section className="text-center group" style={{
          backgroundColor: color !== undefined ? color.hex : '#fff',
          borderTop: newColor  !== undefined ? `1px solid ${newColor}` : 'none',
          borderBottom: newColor  !== undefined ? `1px solid ${newColor}` : 'none',
        }}>
        {data && data.map((dataItem) => {
        switch (dataItem._type) {
          case 'cc_title_section':
            return <Title title={dataItem.cc_title_section_heading} subTitle={dataItem.cc_title_section_title} />;
          case 'modules':
            switch (dataItem.custom_module_blocks) {
              case 'news_module':
                return <Blog />;
              case 'features_module':
                return <Feature />;
              case 'testimonials_module':
                return <Testimonials />;
              case 'prices_module':
                return <Pricing />;
              case 'teams_module':
                return <TeamProfile />;
              case 'contact_form_module':
                return <Contact />;
              default:
                return null;
            }
          case 'cc_accordion':
            return <Process data={dataItem.groups}/>;
          case 'tutorial':
            return <Tutorial data={dataItem.groups} />;
          case 'gallery':
            return <Screenshots data={dataItem.imageUrl}/>;
          case 'video':
            return <Video data={dataItem}/>;
          case 'cc_img_section':
              return <ImageBlock data={dataItem}></ImageBlock>;
          case 'cc_breaker':
              return <Breaker></Breaker>;
          case 'cc_box_content':
              boxContentData.push(dataItem);  
              if (!renderedBoxContent) {
                  renderedBoxContent = true; // Set the flag to true so no further BoxContent is rendered
                  return <BoxContent  data={boxContentData} />;
              }
              return null; 
          default:
            return null;
        }
      })}
        </section>}
        
        </>
    );
}

export default Groups;